import { SET_SAS_PARENT } from "../constant";

const SASReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_SAS_PARENT:
            return {
                ...state,
                data: action.data
            }
        default:
            return state
    }
}

export default SASReducer